export default __webpack_public_path__ + "static/media/IMG0546.9c81cc16.jpg";